import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import './master-detail.component.scss';
import { generateId, isEmptyArray } from '../../common/util.services';
import { ALL, EMPTY_STRING, PAGE_SIZE } from '../../common/constants';
import { searchMasterDetailData } from '../../master-data/masterdata.services';
import IDialogComponent from '../../../components/dialog/i-dialog.component';
import SpecsComponent from '../../master-data/specs/specs.component';
import MasterDataSearchPanel from '../../master-data/master-data-search-panel.component';

const MasterDetailComponent = (props: any) => {

  const appContext = useContext(AppContext);
  const [open, setOpen] = useState(false);
  const rows: GridRowsProp = [];
  const [masterDetail, setMasterDetail] = useState(rows);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [popupRowData, setPopupRowData] = useState(null);
  const [searchData, setSearchData] = useState({ searchText: EMPTY_STRING, type: ALL, input: ALL, 
                                                 isLatestOnly: true, latestOnly: 1, supplier: ALL });
  const columns: GridColDef[] = [
    { 
      field: 'code', headerName: 'Code', filterable: false, sortable: false, width: 120,
      renderCell: (params) => { return <div className="cell-link" onClick={() => { openSpecsPopup(params) }}>{params.row.code}</div> }
    },
    { field: 'input', headerName: 'Input', filterable: false, sortable: false, width: 175 },
    { field: 'description', headerName: 'Description', filterable: false, sortable: false, width: 180 },
    { field: 'uom', headerName: 'UOM', filterable: false, sortable: false, width: 100 },
    { field: 'supplier', headerName: 'Supplier', filterable: false, sortable: false, width: 200 },
    { field: 'unitCost', headerName: 'Unit Cost', filterable: false, sortable: false, width: 100 },
    { field: 'processLossPercentage', headerName: 'PL (%)', filterable: false, sortable: false, width: 65 },
    { field: 'version', headerName: 'Version', filterable: false, sortable: false, width: 70 },
    { field: 'moq', headerName: 'MOQ', filterable: false, sortable: false, width: 100 },
    { field: 'source', headerName: 'Source', filterable: false, sortable: false, width: 120 }
  ];
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    if (isEmptyArray(rows)) {
      searchMasterDetailData(searchData, page, pageSize, appContext,
        (response: any) => {
          setMasterDetail(response.data.data);
          setTotalRows(response.data.totalElements);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          setLoading(false);
        });
    }
  }, [searchData, page, pageSize]);

  const openSpecsPopup = (params: any) => {
    setPopupRowData(params.row);
    setOpen(true);
  }

  const onRowSelection = () => {
    if(selectedRows.length < 1) {
      appContext.setDialogMessage('Select a row.');
    }
    else if (props.onRowSelection) {
      selectedRows[0].linkId = generateId();
      if('Fabric' === selectedRows[0].input) {
        selectedRows[0].outputUom = 'Mtr';
      }
      props.onRowSelection(selectedRows);
    }
  }
  
  const onRowSelectionModelChange = (ids: any) => {
    const selectedIds = new Set(ids);
    const selectedRowData = masterDetail.filter((row) =>
      selectedIds.has(row.linkId)
    );
    setSelectedRows(selectedRowData);
  }

  const handleClose = () => {
    setOpen(false);
  }

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  const search = (searchData: any) => {
    setSearchData(searchData);
  }

  return <div className='master-detail'>
    <MasterDataSearchPanel search={search} searchData={searchData} costing={true}/>
    <IGridComponent title='' showAddBtn={false} rows={masterDetail} columns={columns} maxHeight={"50vh"}
      getRowId={(row: any) => row.linkId} disableMultipleRowSelection={true} loading={loading}
      showExtBtn={true} extBtnAction={onRowSelection} extBtnText={'Select'}
      paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows}
      checkboxSelection={true} disableRowSelectionOnClick={true} rowSelectionModelChange={onRowSelectionModelChange} />
    <IDialogComponent onClose={handleClose} open={open} title='Specifications' dialogClass={'spec-panel'} 
      dialogBody={<SpecsComponent data={popupRowData} />} />
  </div>
}

export default MasterDetailComponent;